/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { SystemConstants } from "@/common/system-constants";
import { Observable } from "rxjs/internal/Observable";
import { map } from "rxjs/operators";
import HttpClient from "./http-client";
import { APIHosts, ApiReduxHelpers } from "./reduxHelpers";

export interface WorkflowContext {
  fileId?: string;
  document_id?: string;
  file_name?: string;
  file_size?: number;
  mime_type?: string;
  template_id?: string;
  template_version?: string;
  max_file_size?: number;
  supported_formats?: string[];
}

export interface WorkflowTask {
  id: string;
  name: string;
  status?: "pending" | "running" | "completed" | "failed";
  created_at: string;
  started_at: string;
  completed_at: string | null;
  duration: number | null;
  error_message: string | null;
  retry_count: number;
  queue: string;
  depends_on: string[];
}

export interface WorkflowDetail {
  id: string;
  name: string;
  status?: "pending" | "running" | "completed" | "failed";
  created_at: string;
  started_at: string;
  completed_at: string | null;
  duration: number | null;
  tasks: WorkflowTask[];
}

export interface Workflow {
  id: string;
  name: string;
  status?: "pending" | "running" | "completed" | "failed";
  created_at: string;
  started_at: string;
  completed_at: string | null;
  created_by: string;
  task_count: number;
  context: WorkflowContext;
}

export interface WorkflowsResponse {
  document_id: string;
  workflows: Workflow[];
  total: number;
  limit: number;
  offset: number;
}

class WorkflowApiController extends ApiReduxHelpers {
  constructor() {
    super();
  }
  ApiHost = APIHosts.Workflow;

  getWorkflowsByDocumentId(
    documentId: string,
    limit: number = 100,
    offset: number = 0
  ): Observable<WorkflowsResponse> {
    const api = SystemConstants.SERVER_WORKFLOW.API.DOCUMENT.GET_WORKFLOWS(
      documentId
    );
    const url = `${this.getHost(this.ApiHost)}/${api}?limit=${limit}&offset=${offset}`;

    return HttpClient.get(url).pipe(
      map((res) => res as WorkflowsResponse)
    );
  }

  getWorkflowStatus(workflowId: string): Observable<WorkflowDetail> {
    const url = `${this.getHost(this.ApiHost)}/workflows/${workflowId}/status`;

    return HttpClient.get(url).pipe(
      map((res) => res as WorkflowDetail)
    );
  }
}

export const WorkflowApi = new WorkflowApiController();
